import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            introduce: '',
            oneWord: '',

            premiumStart: '',
            premiumEnd: '',
            premiumMemberValue: '',
            password:'',
            passwordConfirm:'',

        }
    },
    validators: {
        introduce: function (value) {
            return Validator.value(value)
        },
        oneWord:function (value) {
            return Validator.value(value)
        },
        files: function (value) {
            return Validator.value(value)
        },
        premiumDate: function (value) {
            return Validator.value(value)
        },
        premiumStart: function (value) {
            return Validator.value(value)
        },
        premiumEnd: function (value) {
            return Validator.value(value)
        },
        password: function (value) {
            return Validator.value(value)
                .required('비밀번호를 입력해 주세요.')
                .minLength(8, '비밀번호는 8~16자 이내로 입력해 주세요.')
                .maxLength(16, '비밀번호는 8~16자 이내로 입력해 주세요.')

        },
        passwordConfirm: function (value) {
            return Validator.value(value)
                .required('비밀번호 확인을 입력해 주세요.')
                .custom(() => {
                    if(this.password != value) {
                        return '비밀번호와 같지 않습니다.'
                    }
                })
        },
        id: function (value) {
            return Validator.value(value)
                .required('아이디를 입력해주세요.')
        },
        premiumMemberValue: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.memberType === 0) {
                        return '일치하는 회원이 없습니다.'
                    }
                })
                .required('아이디를 확인해주세요.')
        },
    }
}
